import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useEffect } from "react";
import { useLocation, NavLink, useHistory } from "react-router-dom";
import "./Leads.css";
import api from "../../seller-apis/api";
import UnlockPopup from "./popup/UnlockPopup";
import Popup from "../common/Popup";
import { formatedDate } from "../../utilities/ConvertDateFormat";
import { Actions } from "../../Actions/Actions";
import StatusUpdatePopup from "./popup/statusUpdatePopup";
import SubscriptionView from "./SubscriptionView";
import WalletPopup from "../WalletTransaction/walletPopup";
import UnlockPopupSuccess from "./popup/UnlockPopupSuccess";
var filterData = {
  pageNo: 1,
  size: 6,
  vendorFilter:{
    'status':{'$ne':'LOCKED'}
  }
};
var filterDataLocked = {
  pageSize: 1,
  size: 6,
  vendorFilter:{
    'status':'LOCKED'
  }
};
const Leads = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [leads, setLeads] = useState([]);
  const [showUnlock, setShowUnlock] = useState(false);
  const [showWalletPopup, setShowWalletPopup] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(false);
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [lockedLeads, setLockedLeads] = useState([]);
  const [isDetailPopupVis, setisDetailPopupVis] = useState(false);
  const [productDetail, setproductDetail] = useState([]);
  const [statusToBeUpdated, setStatusToBeUpdated] = useState("");
  const [statusObject, setStatusObject] = useState({});
  const [showUnlockSuccess, setShowUnlockSuccess] = useState(false);
  const walletAmt=useSelector(state=>state.ActionReducer.WalletAmount);
  

  function getLeads(data = filterData) {
    // api.QandA.fetchQA(fetchunansQA(data)).then((res) => {
    api.customerLeads.getLeads(filterData).then((res) => {
      // Actions.leadCount(dispatch,res.data.totalRecords);
      setLeads(res.data.records);
    });
    api.customerLeads.getLeads(filterDataLocked).then((res) => {
      let tempLockedArray=[];
      let otherLeads=[];
      Actions.leadCount(dispatch,res.data.totalRecords);
      //   setLeads(res.data.records);
      // console.log("jjjjjjjjjjjjjjjjjjjjjjjjjj",res);
      // res.data.records.forEach(element => {
      //   if(element?.vendorDetails?.vendors[0]?.status != "LOCKED"){
      //     otherLeads.push(element);
      //   }
      //   else{
      //     tempLockedArray.push(element);
      //   }
      // });
    setLockedLeads(res.data.records);
  });
  }
  useEffect(() => {
    if (localStorage.getItem("vendorState") === "partialInactive") {
      history.replace("/home");
			return false;
    }
    getLeads(filterData);
  }, []);
  const handleUnlockClose = () => {
    setShowUnlock(false);
  };
  const updateSatus = (leadId, status) => {
    let param = {
      _id: leadId,
      status: status,
    };

    api.customerLeads
      .updateStatus(param)
      .then((data) => {
        status === "OPEN" && setShowUnlockSuccess(true);
        setShowUnlock(false);
        getAmount();
        getLeads();
        
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getAmount = () => {
    api.customerLeads.getWalletBallence().then((data) => {
      
      // setCurrWalletBal(data?.data?.record?.wallet?.currentBal);
      Actions.upadteWalletAmount(
        dispatch,
        data?.data?.record?.wallet || []
      );
    });
  };
  const productDetails = (data) => {
    setisDetailPopupVis(true);
    setproductDetail([data]);
  };
  const setpopupVisibilityDetail = () => {
    setisDetailPopupVis(false);
  };
  return (
    <><div className="row mb-4 py-2 border-bottom-1">
      <div className="col-md-9"></div>
      <div className="col-md-3 text-right dis-flex">
        {/* <SubscriptionView /> */}
      </div>
    </div><div className="row p-4" style={{ alignItems: "unset" }}>

        <div className="col-md-6">
          <div class="card">
            <div class="card-header dis-flex justify-content-between lead-status-button">
              <div className="fs-14">Purchased Leads</div>
              <NavLink to="/customer-leads/details">
                <button className="apply-btn">View All</button>
              </NavLink>
            </div>
            <ul
              class="list-group list-group-flush"
              style={{ maxHeight: 447, overflowY: "auto" }}
            >
              {leads.length > 0 &&
                leads.map((item, index) => {
                  return (
                    <>
                      {item?.vendorDetails?.vendors[0]?.status != "LOCKED" && (
                        <li class="list-group-item leads-border-bottom">
                          <div className="row" style={{ alignItems: "unset" }}>
                            <div className="col-md-6  leads-details">
                              <div className="mb-2 product-name">
                                {item?.product?.productName} <br />{" "}
                                <div className="question-sku-but">
                                  <div
                                    className="prod-sku w-100 cursor-pointer"
                                    onClick={() => productDetails(item?.product)}
                                  >
                                    <a href="#popupDetail" className="prod-sku">
                                      SKU : {item?.product.SKU}
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div className="details">
                                <div className="mb-2 dis-flex">
                                  <i class="fa fa-user" aria-hidden="true"></i>
                                  {item.name}
                                </div>
                                {/* <div className="mb-2 dis-flex">
                                  <i
                                    class="fa fa-map-marker"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  {item.state}, {item.pincode}
                                </div> */}
                                <div className="mb-2 dis-flex">
                                  <i class="fa fa-phone" aria-hidden="true"></i>{" "}
                                  {item?.vendorDetails?.vendors[0]?.status !=
                                    "LOCKED" ? (
                                    item.phone
                                  ) : (
                                    <div className="blur-phone">0000000000</div>
                                  )}
                                </div>
                                <div className="mb-2 dis-flex">
                                <b>Customer remarks</b>{" "}
                                  {item.remark}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="text-right mb-2">
                                {formatedDate(item.createdAt)}
                              </div>
                              {/* <div className="text-right mb-2">
                              <b>Expected price : </b>&#8377; {item?.product?.expectedPrice}
                              </div>
                              <div className="text-right mb-2">
                                <b>Quantity : </b>{item?.quantity}
                              </div> */}
                            </div>
                          </div>
                        </li>
                      )}
                    </>
                  );
                })}
              {leads.length == 0 && (
                <li>
                  <div className="text-center py-5">No leads available</div>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="col-md-6">
          <div class="card">
            <div class="card-header dis-flex justify-content-between lead-status-button">
              <div className="fs-14">Leads To Buy</div>
              <NavLink to="/locked-leads">
                <button className="apply-btn">View All</button>
              </NavLink>
            </div>
            <ul
              class="list-group list-group-flush"
              style={{ maxHeight: 447, overflowY: "auto" }}
            >
              {lockedLeads.length > 0 &&
                lockedLeads.map((item, index) => {

                  return (
                    <>
                      {item?.vendorDetails?.vendors[0]?.status == "LOCKED" && (
                        <li class="list-group-item leads-border-bottom">
                          <div className="row" style={{ alignItems: "unset" }}>
                            <div className="col-md-6 leads-details">
                              <div className="mb-2 product-name">
                                {item?.product?.productName} <br />{" "}
                                <div className="question-sku-but">
                                  <div
                                    className="prod-sku w-100 cursor-pointer"
                                    onClick={() => productDetails(item?.product)}
                                  >
                                    <a href="#popupDetail" className="prod-sku">
                                      SKU : {item?.product.SKU}
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div className="details">
                                <div className="mb-2 dis-flex">
                                  <i class="fa fa-user" aria-hidden="true"></i>
                                  {item.name}
                                </div>
                                {/* <div className="mb-2 dis-flex">
                                  <i
                                    class="fa fa-map-marker"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  {item.state}, {item.pincode}
                                </div> */}
                                <div className="mb-2 dis-flex">
                                  <i class="fa fa-phone" aria-hidden="true"></i>{" "}
                                  {item?.vendorDetails?.vendors[0]?.status !=
                                    "LOCKED" ? (
                                    item.phone
                                  ) : (
                                    <div className="blur-phone">0000000000</div>
                                  )}
                                </div>
                                <div className="mb-2 dis-flex">
                                <b>Customer remarks :</b>{" "}
                                  {item.remark}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="text-right mb-2">
                                {formatedDate(item.createdAt)}
                              </div>
                              {/* <div className="text-right mb-2">
                              <b>Expected price : </b>&#8377; {item?.product?.expectedPrice}
                              </div>
                              <div className="text-right mb-2">
                                <b>Quantity : </b>{item?.quantity}
                              </div> */}
                              <div className="text-right mb-2">
                                {(leads.length<5 || walletAmt?.freeBal>0)?<button
                                  className="apply-btn unlock-button"
                                  onClick={() => {
                                    setStatusObject({ "title": ``, "subTitle": "Are you sure want to unlock this lead?" });
                                    setStatusToBeUpdated("OPEN");
                                    setSelectedPrice(item?.leadPrice);
                                    setSelectedLeadId(item._id);
                                    setShowUnlock(true);
                                  } }
                                >
                                  Unlock
                                </button>:
                                <button
                                  className="apply-btn unlock-button"
                                  onClick={() => {
                                    walletAmt?.currentBal>0&&setStatusObject({ "title": ``, "subTitle": "Are you sure want to unlock this lead?" });
                                    walletAmt?.currentBal>0&&setStatusToBeUpdated("OPEN");
                                    walletAmt?.currentBal>0&&setSelectedPrice(item?.leadPrice);
                                    walletAmt?.currentBal>0&&setSelectedLeadId(item._id);
                                    walletAmt?.currentBal>0&&setShowUnlock(true);
                                    walletAmt?.currentBal<=0&&setShowWalletPopup(true);
                                  } }
                                >
                                  Unlock
                                </button>}
                              </div>
                            </div>
                          </div>
                        </li>
                      )}
                    </>
                  );
                })}
              {lockedLeads.length == 0 && (
                <li>
                  <div className="text-center py-5">No leads available</div>
                </li>
              )}
            </ul>
          </div>
        </div>
        <StatusUpdatePopup
          show={showUnlock}
          handleUnlockClose={handleUnlockClose}
          updateSatus={updateSatus}
          status={statusToBeUpdated}
          statusObject={statusObject}
          leadId={selectedLeadId}
          selectedPrice={selectedPrice} />
          <WalletPopup show={showWalletPopup} handleClose={()=>setShowWalletPopup(false)} />
          <UnlockPopupSuccess
            show={showUnlockSuccess}
            handleUnlockClose={()=>setShowUnlockSuccess(false)}
          />
        {isDetailPopupVis && (
          <div id="popupDetail" className="overlay" style={{ display: "block" }}>
            <Popup
              from="newOrder"
              description={productDetail[0].desc}
              sdescription={productDetail[0].sDesc}
              descriptionNew={productDetail[0].descriptionNew}
              specificationNew={productDetail[0].specificationNew}
              name={productDetail[0].productName}
              // price={detailPPrice}
              SKU={productDetail[0].SKU}
              popupVisibility={setpopupVisibilityDetail}
              images={productDetail[0].image}
              videos={productDetail[0].video} />
          </div>
        )}
      </div></>
  );
};

export default Leads;
